import React from "react";
import { NavLinks } from "../WalletSection/NavLinks";
import { StartTradingButton } from "../StartTradingButton/StartTradingButton";
import { WavyHamburger } from "components/Icons";
import { useIsDesktop } from "hooks/useDeviceType";
import { Spacer } from "components/general/Spacer/Spacer";
import styled from "@emotion/styled";

interface NavbarProps {
  setIsSideNavOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Navbar = ({ setIsSideNavOpen }: NavbarProps) => {
  const isDesktop = useIsDesktop();

  const SideNavSandwich = () => {
    return (
      <MenuButton
        type="button"
        data-bs-toggle="collapse"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={() => {
          setIsSideNavOpen(true);
        }}
      >
        <WavyHamburger width={28} height={28} />
      </MenuButton>
    );
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {isDesktop && (
        <>
          <NavLinks />
          <Spacer width={104} />
        </>
      )}
      <StartTradingButton />
      {!isDesktop && <SideNavSandwich />}
    </div>
  );
};

// Sub-components

const MenuButton = styled.button`
  background: ${props => props.theme.surface.main.secondary.default};
  border-radius: 50%;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 12px;

  &:hover {
    background-color: ${props => props.theme.surface.main.primary.hover};
  }
`;
